
import React, { PropTypes } from 'react';

export class CashSek extends React.Component {

  static propTypes = {
    colorSchema: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string
  };

  render () {
    const fill = this.props.colorSchema === 'primary'
      ? '#00587c'
      : '#000000';

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width || '20'}
        height={this.props.height || '20'}
        viewBox="0 0 20 20"
      >
        <path
          d="M19,17.55H1c-0.276,0-0.5-0.225-0.5-0.5v-10c0-0.276,0.224-0.5,0.5-0.5h18c0.275,0,0.5,0.224,0.5,0.5v10
          C19.5,17.325,19.275,17.55,19,17.55z M1.5,16.55h17v-9h-17V16.55z"
          fill={fill}
        />
        <path
          d="M18,5.55H2c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h16c0.275,0,0.5,0.224,0.5,0.5S18.275,5.55,18,5.55z"
          fill={fill}
        />
        <path
          d="M17,3.55H3c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h14c0.275,0,0.5,0.224,0.5,0.5S17.275,3.55,17,3.55z"
          fill={fill}
        />
        <g>
          <path
            d={'M5.125,14.458c-0.248-0.065-0.441-0.149-0.581-0.252c-0.131-0.089-0.196-0.177-0.196-0.266c0-0.07,'+
            '0.026-0.154,0.077-0.252'+
            ' c0.051-0.099,0.112-0.185,0.182-0.259c0.07-0.075,0.128-0.112,0.175-0.112c0.028,0,0.093,0.028,0.196,0.084'+
            ' c0.149,0.074,0.284,0.133,0.406,0.175s0.264,0.063,0.427,0.063c0.182,0,0.337-0.036,0.465-0.109'+
            ' c0.128-0.072,0.192-0.199,0.192-0.381c0-0.149-0.06-0.268-0.178-0.354c-0.119-0.087-0.312-0.184-0.578-'+
            '0.291l-0.322-0.14'+
            ' c-0.294-0.14-0.525-0.313-0.693-0.521s-0.252-0.503-0.252-0.886c0-0.317,0.078-0.582,0.234-0.794'+
            ' c0.156-0.212,0.361-0.369,0.613-0.469c0.252-0.1,0.522-0.15,0.812-0.15c0.238,0,0.454,0.024,0.647,0.074'+
            ' C6.946,9.667,7.098,9.73,7.211,9.81c0.103,0.075,0.154,0.149,0.154,0.224c0,0.065-0.021,0.147-0.063,0.245'+
            ' s-0.093,0.184-0.154,0.256c-0.061,0.072-0.117,0.108-0.168,0.108c-0.023,0-0.062-0.012-0.116-0.035s-0.099-'+
            '0.042-0.136-0.057'+
            ' c-0.168-0.056-0.343-0.084-0.525-0.084c-0.243,0-0.412,0.04-0.507,0.119c-0.096,0.08-0.144,0.171-0.144,'+
            '0.273'+
            ' c0,0.121,0.033,0.222,0.098,0.301s0.145,0.144,0.238,0.192s0.231,0.113,0.413,0.192c0.266,0.112,0.483,0.219'+
            ',0.651,0.318'+
            ' c0.168,0.101,0.314,0.245,0.438,0.435c0.124,0.188,0.186,0.431,0.186,0.725c0,0.359-0.076,0.653-0.228,0.882'+
            ' c-0.151,0.229-0.346,0.395-0.584,0.497c-0.238,0.103-0.495,0.154-0.77,0.154C5.661,14.556,5.372,14.523,'+
            '5.125,14.458z'}
            fill={fill}
          />
          <path
            d={'M8.292,14.433c-0.044-0.044-0.066-0.115-0.066-0.213V9.88c0-0.098,0.022-0.169,0.066-0.213'+
            ' C8.336,9.622,8.407,9.6,8.506,9.6h2.458c0.074,0,0.128,0.028,0.161,0.084c0.032,0.056,0.049,0.145,0.049,'+
            '0.266v0.217'+
            ' c0,0.122-0.017,0.209-0.049,0.266c-0.033,0.056-0.087,0.084-0.161,0.084h-1.66v1.015h1.47c0.075,0,0.129,'+
            '0.028,0.161,0.084'+
            ' s0.049,0.145,0.049,0.266v0.218c0,0.121-0.017,0.21-0.049,0.266s-0.086,0.084-0.161,0.084h-1.47v1.134h1.667'+
            ' c0.074,0,0.128,0.028,0.161,0.084c0.032,0.057,0.049,0.145,0.049,0.267v0.217c0,0.121-0.017,0.21-0.049,'+
            '0.266'+
            ' c-0.033,0.057-0.087,0.084-0.161,0.084H8.506C8.407,14.5,8.336,14.478,8.292,14.433z'}
            fill={fill}
          />
          <path
            d={'M11.998,14.29V9.81c0-0.149,0.141-0.224,0.42-0.224h0.245c0.28,0,0.42,0.075,0.42,0.224v1.876l0.028,'+
            '0.007l1.218-1.974'+
            ' c0.052-0.089,0.191-0.133,0.42-0.133h0.329c0.262,0,0.393,0.035,0.393,0.105c0,0.042-0.019,0.091-0.057,'+
            '0.147l-1.351,2.072'+
            ' l1.533,2.353c0.037,0.056,0.056,0.104,0.056,0.146c0,0.07-0.131,0.105-0.392,0.105h-0.406c-0.233,'+
            '0-0.376-0.045-0.427-0.134'+
            ' l-1.316-2.128l-0.028,0.007v2.03c0,0.149-0.14,0.225-0.42,0.225h-0.245C12.139,14.514,11.998,14.439,11.998,'+
            '14.29z'}
            fill={fill}
          />
        </g>
      </svg>
    );
  }
}

export default CashSek;



/** WEBPACK FOOTER **
 ** ./src/components/svg/cash-sek.js
 **/